import React, { useState, useEffect } from 'react';
import { Workspace } from './types';

interface RenameWorkspaceDialogProps {
  isOpen: boolean;
  workspace: Workspace | null;
  onClose: () => void;
  onRename: (id: string, newName: string) => void;
}

const RenameWorkspaceDialog: React.FC<RenameWorkspaceDialogProps> = ({
  isOpen,
  workspace,
  onClose,
  onRename,
}) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (workspace) {
      setName(workspace.name);
    }
  }, [workspace]);

  if (!isOpen || !workspace) return null;

  const handleRename = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onRename(workspace.id, trimmed);
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && name.trim()) {
      handleRename();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="workspace-dialog-overlay" onClick={onClose} role="presentation">
      <div
        className="workspace-dialog"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="rename-ws-title"
      >
        <h3 id="rename-ws-title">Rename Workspace</h3>

        <div className="workspace-dialog-field">
          <label htmlFor="rename-ws-name">Name</label>
          <input
            id="rename-ws-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
            maxLength={30}
            aria-required="true"
          />
        </div>

        <div className="workspace-dialog-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary-ws"
            onClick={handleRename}
            disabled={!name.trim()}
          >
            Rename
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameWorkspaceDialog;
